import React from "react";
import logdna from "@logdna/browser";
import { useUserSlice } from "src/store/features/user.slice";
import { getRuntimeConfig } from "src/getRuntimeConfig";

declare global {
  interface Window {
    __LogDNA__?: any;
  }
}

type Props = {
  children: React.ReactNode;
};

const LOGDNAWrapper = ({ children }: Props) => {
  const { details } = useUserSlice();

  const env = getRuntimeConfig().CNB_ENV ?? "dev";
  React.useEffect(() => {
    if (env !== "dev") {
      const logdnaKey = getRuntimeConfig().LOGDNA_INGESTION_KEY as string;

      logdna.init(logdnaKey, {
        hostname: `zurich-frontend-${env}`,
        tags: `zurich-frontend-${env}`,
        hooks: {
          beforeSend: [
            ({ message, level, lineContext }): any => {
              // Convert message to string if it is not already
              const messageStr = typeof message === "string" ? message : JSON.stringify(message);

              // Convert lineContext to string if it is not already
              const lineContextStr =
                typeof lineContext === "string" ? lineContext : JSON.stringify(lineContext);

              // Check if message or lineContext contains the undesired string
              if (!messageStr || !lineContextStr) return null;
              if (
                messageStr.includes("Amplitude") ||
                messageStr.includes("accessToken") ||
                messageStr.includes("refreshToken") ||
                lineContextStr.includes("Amplitude") ||
                lineContextStr.includes("accessToken") ||
                lineContextStr.includes("refreshToken")
              ) {
                return null; // Stop the message from being sent to LogDNA
              }

              return { message, level, lineContext };
            },
          ],
        },
      });

      const userId = details.customerId || "Unknown";
      logdna.addContext({
        user: {
          userId: userId,
        },
      });
    }
  }, [details, env]);

  return <>{children}</>;
};

export default LOGDNAWrapper;
